import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem('bm_theme') || 'artistic');
  const [stringsOn, setStringsOn] = useState(() => localStorage.getItem('bm_strings') !== 'off');
  const [soundOn, setSoundOn] = useState(false);

  useEffect(() => {
    localStorage.setItem('bm_theme', theme);
    const root = document.documentElement;
    if (theme === 'luxury') root.classList.add('theme-lux');
    else root.classList.remove('theme-lux');
  }, [theme]);

  useEffect(() => {
    localStorage.setItem('bm_strings', stringsOn ? 'on' : 'off');
  }, [stringsOn]);

  const value = {
    theme,
    setTheme,
    toggleTheme: () => setTheme((t) => (t === 'artistic' ? 'luxury' : 'artistic')),
    stringsOn,
    setStringsOn,
    soundOn,
    setSoundOn,
  };
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
